module.exports = __webpack_public_path__ + "static/media/thor.703dc8a6.jpg";